import { useTranslation } from 'react-i18next';
import { ClipboardList, FileText, Calendar, CheckSquare } from 'lucide-react';
import { fmtDay } from './formatDay';
import StatusBadge from './StatusBadge';

export default function ConsultationTaskCard({ task }) {
  const { t } = useTranslation('consulting');

  const items = task.items || [];
  const doneCount = items.filter((i) => i.is_done).length;
  const Icon = task.is_essay ? FileText : ClipboardList;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm mb-3 p-3 sm:p-4">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center bg-[#589DD5]/10 text-[#589DD5]">
          <Icon className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.5} />
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-semibold text-gray-900 dark:text-white text-sm sm:text-base truncate">
              {task.title}
            </h3>
            <StatusBadge status={task.status} />
            {task.is_essay && (
              <span className="px-1.5 py-0.5 text-[10px] font-medium rounded-full bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300">
                {t('card.essay')}
              </span>
            )}
          </div>

          <div className="mt-1 flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400 flex-wrap">
            <span className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              {task.due_at
                ? t('card.due', { date: fmtDay(task.due_at) })
                : t('card.noDue')}
            </span>
            {items.length > 0 && (
              <span className="flex items-center gap-1">
                <CheckSquare className="w-3 h-3" />
                {t('card.checklist', { done: doneCount, total: items.length })}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
